<template>
  <div class="container">
    <div class="head">
      <el-button type="primary" @click="addProduct">添加会员产品</el-button>
    </div>
    <el-dialog
      title="会员产品"
      :destroy-on-close="true"
      :visible.sync="dialogFormVisible"
    >
      <el-form :model="form" ref="form" :rules="formRules">
        <el-form-item label="名称" prop="name" :label-width="formLabelWidth">
          <el-input class="item" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item
          label="支付方式"
          prop="type"
          :label-width="formLabelWidth"
        >
          <el-select v-model="form.type" placeholder="请选择支付方式">
            <el-option label="普通续费" value="r"></el-option>
            <el-option label="会员卡" value="uc"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="开始时间"
          prop="start_time"
          :label-width="formLabelWidth"
        >
          <el-date-picker
            v-model="form.start_time"
            type="datetime"
            placeholder="选择日期时间"
            :picker-options="startTime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          label="结束时间"
          prop="expire_time"
          :label-width="formLabelWidth"
        >
          <el-date-picker
            v-model="form.expire_time"
            type="datetime"
            placeholder="选择日期时间"
            :picker-options="endTime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          label="原价"
          prop="original_price"
          :label-width="formLabelWidth"
        >
          <el-input class="item" v-model="form.original_price" min="0">
            <template slot="append"
              >分</template
            >
          </el-input>
        </el-form-item>
        <el-form-item
          label="售价"
          prop="final_price"
          :label-width="formLabelWidth"
        >
          <el-input class="item" v-model="form.final_price" min="0">
            <template slot="append"
              >分</template
            >
          </el-input>
        </el-form-item>
        <el-form-item
          label="会员时长"
          prop="time"
          :label-width="formLabelWidth"
        >
          <el-input class="item" v-model.number="form.time" min="0">
            <template slot="append"
              >天</template
            >
          </el-input>
        </el-form-item>
        <el-form-item
          label="level"
          prop="level"
          :label-width="formLabelWidth"
        >
          <el-select v-model="form.level" placeholder="请选择level">
            <el-option label="level:1" value="1"></el-option>
            <el-option label="level:2" value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitInfo">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="分配会员" :visible.sync="dialogInput"
      >用户ID:
      <el-input
        class="item"
        v-model="userId"
        placeholder="请输入用户ID"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogInput = false">取 消</el-button>
        <el-button type="primary" @click="toAssignMembers">确 定</el-button>
      </div>
    </el-dialog>
    <div class="table-container">
      <el-table :data="tableData" stripe border="" style="width: 100%">
        <el-table-column prop="id" label="ID" width="120"></el-table-column>
        <el-table-column prop="name" label="名称" width="120"></el-table-column>
        <el-table-column prop="channel" label="渠道" />
        <el-table-column
          prop="type_en"
          label="支付方式"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="status_name"
          label="状态"
          />
        <el-table-column prop="start_time" label="开始时间"></el-table-column>
        <el-table-column prop="expire_time" label="过期时间"></el-table-column>
        <el-table-column
          prop="original_price"
          label="原价(元)"
        ></el-table-column>
        <el-table-column prop="final_price" label="售价(元)"></el-table-column>
        <el-table-column
          prop="category.member_second"
          label="会员时长(天)"
        ></el-table-column>
        <el-table-column
          prop="category.level"
          label="level"
        ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- <el-button @click="handleEdit(scope.$index, scope.row)">操作记录</el-button> -->
            <el-button
              size="small"
              v-if="scope.row.type === 'r' && scope.row.status === 100 && !scope.row.channel"
              @click="assignMembers(scope.$index, scope.row)"
              >分配会员</el-button
            >
            <el-button
              size="small"
              @click="handleChangeStatus(100, scope.row)"
              v-if="scope.row.status === 0"
              type="primary"
            >上架</el-button>
            <el-button
              size="small"
              @click="handleChangeStatus(900, scope.row)"
              type="danger"
              v-else-if="scope.row.status === 100"
            >下架</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import request from "../../api/request";
import { format } from "date-fns";

const STATUS_MAP = {
  '0'   : '创建',
  '100' : '开放销售',
  '900' : '已关闭',
}

export default {
  data() {
    const checkNumber = (rule, value, callback) => {
      if (!Number.isInteger(value)) {
        callback(new Error("请输入数字值"));
      } else if (value === "") {
        callback(new Error("输入不能为空"));
      } else if (value < 0) {
        callback(new Error("输入的值不能小于0"));
      } else {
        callback();
      }
    };
    const checkTime = (rule, value, callback) => {
      const isPastTimes =
        new Date(value).getTime() > new Date().getTime() ? false : true;
      if (isPastTimes) {
        callback(new Error("选择时间需要大于当前时间"));
      } else {
        callback();
      }
    };
    const checkName = (rule, value, callback) => {
      if (!value) {
        callback(new Error("名称不能为空"));
      } else {
        callback();
      }
    };
    const checkNumPot2 = (rule, value, callback) => {
      const reg = /(^[0-9]+$)/;
      if (!value) {
        return callback(new Error("请填写数字"));
      } else if (!reg.test(value)) {
        return callback(new Error("请填写数字不含小数"));
      } else {
        callback();
      }
    };

    return {
      tableData: [],
      dialogFormVisible: false,
      dialogInput: false,
      userId: "",
      itemId: "",
      form: {
        name: "",
        start_time: "",
        expire_time: "",
        original_price: "",
        type: "r",
        final_price: "",
        time: "",
        level: ""
      },
      formLabelWidth: "80px",
      formRules: {
        name: [
          {
            validator: checkName,
            trigger: "blur"
          }
        ],
        start_time: [
          {
            validator: checkTime,
            trigger: "blur"
          }
        ],
        expire_time: [
          {
            validator: checkTime,
            trigger: "blur"
          }
        ],
        original_price: [
          {
            validator: checkNumPot2,
            trigger: "blur"
          }
        ],
        final_price: [
          {
            validator: checkNumPot2,
            trigger: "blur"
          }
        ],
        time: [
          {
            validator: checkNumber,
            trigger: "blur"
          }
        ]
      },
      startTime: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      endTime: {
        disabledDate: time => {
          if (this.form.start_time) {
            return new Date(this.form.start_time).getTime() > time.getTime();
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      }
    };
  },
  created() {
    this.getItemList();
  },
  methods: {
    addProduct() {
      this.dialogFormVisible = true;
    },
    submitInfo() {
      this.$refs["form"].validate(async valid => {
        if (valid) {
          const params = {
            type: this.form.type,
            name: this.form.name,
            start_time: format(this.form.start_time, "yyyy-MM-dd HH:mm:ss"),
            expire_time: format(this.form.expire_time, "yyyy-MM-dd HH:mm:ss"),
            original_price: parseInt(this.form.original_price),
            final_price: parseInt(this.form.final_price),
            category: {
              member_second: this.form.time * 8.64e4,
              level: parseInt(this.form.level)
            }
          };
          await request.shop.post("item_setting_create", params);
          this.dialogFormVisible = false;
          this.$message({
            message: "创建成功",
            type: "success"
          });
          this.$refs.form.resetFields();
          this.getItemList();
        } else {
          this.$message({
            message: "创建失败",
            type: "error"
          });
          return false;
        }
      });
    },
    async getItemList() {
      const params = {
        range: [0, 1e6]
      };
      const resp = await request.shop.post("item_setting_list", params);
      this.tableData = resp.data.list.map(item => {
        item.final_price = (item.final_price / 100).toFixed(2);
        item.original_price = (item.original_price / 100).toFixed(2);
        item.category.member_second = item.category.member_second / (3600 * 24);
        if (item.type === "uc") {
          item.type_en = "会员卡";
        } else if (item.type === "r") {
          item.type_en = "普通续费";
        }
        item.status_name = STATUS_MAP[ item.status ] || '未知'
        return item;
      });
    },
    handleEdit() {},
    assignMembers(index, row) {
      this.dialogInput = true;
      this.itemId = row.id;
    },
    async handleChangeStatus(status, row) {
      try {
        await request.shop.post("item_setting_update", {
          setting_id: row.id,
          status: status
        });
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.getItemList();
      } catch (e) {
        console.error(e);
        this.$message({
          message: "操作失败",
          type: "error"
        });
      }
    },
    async toAssignMembers() {
      try {
        this.inputLoading = true;
        await request.shop.post("item_create", {
          setting_id: this.itemId,
          user_id: parseInt(this.userId, 10)
        });
        this.dialogInput = false;
        this.$message({
          message: "分配成功",
          type: "success"
        });
      } catch (e) {
        this.$message({
          message: "分配失败",
          type: "error"
        });
      }
    }
  }
};
</script>

<style scoped>
.head {
  text-align: right;
  margin-bottom: 30px;
}
.item {
  width: 200px;
}
.table-container {
  height: 400px;
}
</style>
